export default "__VITE_ASSET__20ed6383__"